const STORAGE_KEY = "muyeon.lastLoginProvider";

export const LOGIN_PROVIDER = Object.freeze({
  EMAIL: "EMAIL",
  KAKAO: "KAKAO",
  APPLE: "APPLE",
  NAVER: "NAVER",
});

const VALID_PROVIDERS = new Set(Object.values(LOGIN_PROVIDER));

export const getLastLoginProvider = () => {
  try {
    const provider = localStorage.getItem(STORAGE_KEY);
    return VALID_PROVIDERS.has(provider) ? provider : null;
  } catch {
    return null;
  }
};

export const setLastLoginProvider = (provider) => {
  if (!VALID_PROVIDERS.has(provider)) return;
  try { localStorage.setItem(STORAGE_KEY, provider); } catch {}
};
